import { useState } from "react";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import CustomSelect from "../../../component/CustomSelect";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Icons from "../../../myIcon/Icons";

const addCategoryEndPoints = ApiEndpoints.tmsIntegrationCategory.categoryCreate;
const StatusData = [{ _id: "1", name: "Disable" }, { _id: "0", name: "Enable" }];

export default function AddTmsIntegrationCategory({ show, onHide }) {
  const [data, setData] = useState({ name: "", status: "" });

  const handleChange = (e) => setData((prev) => ({ ...prev, [e.target.name || "status"]: e.target.value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!data.name || !data.status) {
      toast.error("All fields are required.");
      return;
    }

    try {
      const response = await ApiRequest("POST", addCategoryEndPoints, data);
      response.error ? toast.error(response.message) : toast.success(response.message);
      if (!response.error) onHide();
    } catch (error) {
      console.error("There was an error creating the category!", error);
    }
  };

  return (
    <Modal className="add-modal-area" show={show} onHide={onHide} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <button className="modal-close-button" onClick={onHide}><Icons name="cross" /></button>
        <form onSubmit={handleSubmit}>
          <div className="add-page-inputs">
            <div className="col-lg-12"><div className="add-page-sections">Create Integration Category</div></div>
            <div className="label-wrap-add"><label>Category<small>*</small></label></div>
            <input name="name" type="text" value={data.name} onChange={handleChange} required className="form-control" placeholder="Enter Here" />
          </div>
          <div className="add-page-inputs">
            <div className="label-wrap-add"><label>Status<small>*</small></label></div>
            <CustomSelect name="status" options={StatusData} placeholder="Select Status" onChange={handleChange} />
          </div>
          <button type="submit" className="default-btn">add<span></span></button>
        </form>
      </Modal.Body>
    </Modal>
  );
}
